import { defineRecipe } from '@chakra-ui/react';
import { pressActive } from './press';

/**
 * Menu row fills. Daylight matches the autocomplete row: `surface` on the
 * paper panel. Night menus are already `surface`, so the row lightens with ink.
 */
export const menuItemHoverBg = { base: 'surface', _dark: 'text/16' } as const;
export const menuItemPressedBg = { base: 'border', _dark: 'text/24' } as const;
export const menuItemSelectedBg = 'accent/28';
export const menuItemSelectedHoverBg = 'accent/36';
export const menuItemSelectedPressedBg = 'accent/42';

/** Merged onto Chakra's button recipe. Treatments and the menu row live here. */
export const buttonRecipe = defineRecipe({
  base: {
    borderWidth: 'hairline',
    _active: pressActive,
  },
  variants: {
    variant: {
      primary: {
        bg: 'accent',
        color: 'bg',
        borderColor: 'transparent',
        _hover: { bg: 'accentHover', color: 'bg' },
        _active: { bg: 'accentMuted', color: 'bg', ...pressActive },
      },
      outline: {
        bg: 'bg',
        borderColor: 'border',
        color: 'text',
        _hover: { bg: 'bgElevated', borderColor: 'accentMuted' },
        _active: { bg: 'surface', ...pressActive },
      },
      ghost: {
        bg: 'transparent',
        color: 'text',
        borderColor: 'transparent',
        _hover: { bg: 'bgElevated', color: 'text' },
        _active: { bg: 'bgElevated', color: 'text', ...pressActive },
      },
      menuItem: {
        bg: 'transparent',
        color: 'text',
        borderColor: 'transparent',
        _hover: { bg: menuItemHoverBg, color: 'text' },
        _active: { bg: menuItemPressedBg, color: 'text', ...pressActive },
      },
      selected: {
        bg: menuItemSelectedBg,
        color: 'accent',
        borderColor: 'accent/45',
        _hover: { bg: menuItemSelectedHoverBg, borderColor: 'accent/55' },
        _active: { bg: menuItemSelectedPressedBg, ...pressActive },
        _focusVisible: {
          outline: 'none',
          borderColor: 'accentMuted',
          boxShadow: '0 0 0 1px var(--chakra-colors-accent-muted)',
        },
      },
    },
  },
});
